import Logo from "../assets/img/logo.svg";
import LogoMeae from "../assets/img/logo_meae.svg";
import FundedHag from "../assets/img/fundedby_hag.svg";

const LogoHead = () => {
  return (
    <div className="flex flex-col lg:flex-row justify-center items-center">
      <a
        href="https://bioport-logistique.com"
        title="BIOPORT Logistique"
        target="_blank"
      >
        <img
          className="h-32 m-auto w-auto lg:mb-10"
          src={Logo}
          alt="BIOPORT Logistique"
        />
      </a>
      <div className="mt-12 lg:mt-0 lg:border-l lg:border-gray-300 flex items-center lg:pl-8 lg:ml-8">
        <img className="h-40 lg:h-36" src={LogoMeae} alt="" />
        <img className="ml-8 h-20 lg:h-32" src={FundedHag} alt="Funded by European Union" />
      </div>
    </div>
  );
};

export default LogoHead;
